module.exports = __webpack_public_path__ + "3fcbe4b01d8cd8591e1d763010164a19.png";